export class ShareClick {
    constructor(optionalOptions = {}) {
        this._buttons = document.querySelectorAll('.share-button');

        if (!this._buttons) {
            this.destructor();
            return true;
        }

        this._buttons.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault()

                window.closeAllModals();

                if (navigator.share) {
                    let linkShare = button.dataset.link ? button.dataset.link : '';
                    let textShare = button.dataset.text ? button.dataset.text : '';
                    let titleShare = button.dataset.title ? button.dataset.title : '';

                    navigator.share({
                        title: titleShare,
                        text: textShare,
                        url: linkShare
                    }).then(() => {}).catch(console.error);
                } else {
                    console.log("Sorry! Your browser does not support Web Share API")
                }

                return false
            })
        })
    }

    destructor() {
        this._buttons = null;
    }
}

export default new ShareClick();